<template>
  <v-container class="loaded">
    <v-row class="flex-col-on-mobile">
      <v-col class="filters">
        <small>{{ $t("tacShop.view") }}</small>
        <v-select
          v-model="selectedView"
          :items="viewItems"
          outlined
          dense
          :disabled="true"
        >
        </v-select>
        <strong style="text-transform: uppercase">{{
          $t("tacShop.courses")
        }}</strong>
        <v-btn depressed color="primary" class="rounded-0" block>
          {{ $t("tacShop.fitnessCourses") }}
        </v-btn>
      </v-col>
      <v-col class="mobile-calendar-controls">
        <v-btn text tile :disabled="!previousWeekEnabled" @click="previousWeek"
          >&lt;</v-btn
        >
        <v-btn text tile :disabled="!nextWeekEnabled" @click="nextWeek"
          >&gt;</v-btn
        >
      </v-col>
      <v-col class="calendar-wrapper">
        <v-btn
          class="mt-16 mx-0 hide-on-mobile"
          depressed
          tile
          text
          :disabled="!previousWeekEnabled"
          @click="previousWeek"
          >&lt;</v-btn
        >
        <v-calendar
          ref="calendar"
          v-model="value"
          :locale="locale"
          :weekdays="[1, 2, 3, 4, 5, 6, 0]"
          :type="'week'"
          :events="events"
          :event-overlap-mode="'stack'"
          :event-overlap-threshold="30"
          :event-color="getEventColor"
          :first-interval="7"
          :interval-count="15"
          @change="getEvents"
          @click:event="viewDetails"
        ></v-calendar>
        <v-btn
          class="mt-16 mx-0 hide-on-mobile"
          depressed
          tile
          text
          :disabled="!nextWeekEnabled"
          @click="nextWeek"
          >&gt;</v-btn
        >
      </v-col>
    </v-row>
    <v-dialog v-model="bookingDialog.show" max-width="600">
      <v-card>
        <v-card-title class="text-h5">
          {{ bookingDialog.title }}
        </v-card-title>
        <v-card-text>
          {{ bookingDialog.dateTime }}
        </v-card-text>
        <v-card-text>
          {{ bookingDialog.description }}
        </v-card-text>

        <v-select
          class="persons-select"
          max-width="10"
          v-model="bookingDialog.persons"
          :items="
            bookingDialog.available
              ? Array.from(
                  { length: bookingDialog.available },
                  (_, index) => index + 1
                )
              : [1]
          "
          :label="$t('tacShop.bookingDialog.numberOfPersons')"
        ></v-select>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" text @click="bookingDialog.onCancel">
            {{ $t("tacShop.bookingDialog.cancel") }}
          </v-btn>

          <v-btn color="primary darken-1" text @click="bookingDialog.onBook">
            {{ $t("tacShop.bookingDialog.book") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bookingSuccessDialog" max-width="350" persistent>
      <v-card>
        <v-card-title class="text-h5">{{
          $t("tacShop.bookingDialog.success")
        }}</v-card-title>
        <v-card-text>{{
          $t("tacShop.bookingDialog.successLongText")
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="onCloseBookingSuccessDialog"
          >
            {{ $t("tacShop.bookingDialog.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bookingFailedDialog" max-width="350" persistent>
      <v-card>
        <v-card-title class="text-h5">{{
          $t("tacShop.bookingDialog.failed")
        }}</v-card-title>
        <v-card-text>{{
          $t("tacShop.bookingDialog.failedLongText")
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="onCloseBookingFailedDialog"
          >
            {{ $t("tacShop.bookingDialog.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showLoadingDialog"
      max-width="350"
      hide-overlay
      persistent
    >
      <v-card
        class="py-12 d-flex flex-column justify-center align-center"
        style="gap: 16px"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
        <p v-if="status === 'logging-in'">{{ $t("tacShop.loggingIn") }}</p>
        <p v-if="status === 'loading-courses'">
          {{ $t("tacShop.loadingCalendar") }}
        </p>
        <p v-if="status === 'booking-in-progress'">
          {{ $t("tacShop.bookingInProgress") }}
        </p>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style scoped>
.container {
  height: 100%;
  width: 100%;
  max-width: 100%;
}
.loaded {
  margin: 0;
  padding-top: 32px;
  background-color: lightgray;
  color: white;
}
.filters {
  background-color: white;
  color: black;
  padding: 16px 24px;
  margin: 0px 4px 8px 8px;
  max-width: 20%;
  min-width: 240px; /* this takes priority over max-width */
}
.calendar-wrapper {
  background-color: white;
  color: black;
  padding: 0px 0px 80px 0px;
  margin: 0px 8px 8px 4px;
  display: flex;
}
.v-calendar {
  background-color: none;
  border: none;
  color: black;
  padding-top: 32px;
  width: 100%;
}
.persons-select {
  max-width: 200px;
  margin-inline-start: 24px;
}
.mobile-calendar-controls {
  display: none;
}
@media (max-width: 600px) {
  .filters {
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
  .v-calendar {
    width: 100%;
    margin-left: -12px;
    margin-right: 8px;
    padding-top: 0;
  }
  .calendar-wrapper {
    margin: 0;
  }
  .hide-on-mobile {
    display: none;
  }
  .flex-col-on-mobile {
    flex-direction: column;
  }
  .mobile-calendar-controls {
    display: flex;
    justify-content: space-between;
    background-color: white;
  }
}
</style>
<style>
.v-calendar-daily_head-day-label > button {
  width: 40px !important;
  height: 40px !important;
}
</style>
<script>
import Vue from "vue";
import { mapState } from "vuex";
export default {
  data: function () {
    return {
      status: "logging-in",
      viewItems: [Vue.i18n.translate("tacShop.weeklyCalendar")],
      selectedView: Vue.i18n.translate("tacShop.weeklyCalendar"),
      value: "",
      colors: [
        "blue",
        "indigo",
        "cyan",
        "green",
        "orange",
        "grey",
        "purple",
        "teal",
        "pink",
        "brown",
        "light-blue",
        "amber",
        "deep-purple",
      ],
      events: [],
      bookingDialog: {
        show: false,
        title: "",
        dateTime: "",
        description: "",
        persons: 1,
        maxNumberOfParticipants: 1,
        onCancel: () => {},
        onBook: () => {},
      },
      bookingSuccessDialog: false,
      bookingFailedDialog: false,
      date: new Date(),
    };
  },
  async mounted() {
    await this.$store.dispatch("tac/postAccountVerify");
    this.status = "loading-courses";
    await this.$store.dispatch("tac/getAllCourses");
    this.status = "loaded";
  },
  methods: {
    getEvents() {
      const events = [];
      for (let i = 0; i < this.allCourses?.courses?.length; i++) {
        const course = this.allCourses.courses[i];
        const startTime = new Date(course.timeSpan.Start);
        const endTime = new Date(course.timeSpan.End);

        if (course.availableNoOfPersons === 0) {
          continue;
        }

        events.push({
          index: i,
          name:
            course.name.find((n) => n.language === this.locale).value ||
            course.name[0].value,
          start: startTime,
          end: endTime,
          color: this.colors[
            course.description[0].value.length % this.colors.length
          ],
          timed: true,
        });
      }
      this.events = events;
      this.value = this.date;
    },
    getEventColor(event) {
      return event.color;
    },
    viewDetails({ event }) {
      const course = this.allCourses.courses[event.index];
      this.bookingDialog = {
        show: true,
        title:
          course.name.find((n) => n.language === this.locale)?.value ||
          course.name[0].value,
        dateTime: this.formatDateRange(
          course.timeSpan.Start,
          course.timeSpan.End
        ),
        description:
          course.description.find((n) => n.language === this.locale)?.value ||
          course.description[0].value,
        persons: 1,
        available: course.availableNoOfPersons,
        onCancel: () => {
          this.bookingDialog.show = false;
        },
        onBook: () => {
          this.status = "booking-in-progress";
          this.$store
            .dispatch("tac/bookCourse", {
              courseId: course.classId,
              numberOfPersons: this.bookingDialog.persons,
            })
            .then(() => {
              this.bookingDialog.show = false;
            })
            .catch(() => {
              this.bookingDialog.show = false;
            });
        },
      };
    },
    async onCloseBookingSuccessDialog() {
      this.bookingSuccessDialog = false;
      this.status = "loading-courses";
      await this.$store.dispatch("tac/getAllCourses");
      this.status = "loaded";
    },
    async onCloseBookingFailedDialog() {
      this.bookingFailedDialog = false;
      this.status = "loading-courses";
      await this.$store.dispatch("tac/getAllCourses");
      this.status = "loaded";
    },
    formatDateRange(start, end) {
      const daysOfWeek = [
        Vue.i18n.translate("tacShop.formatDateRange.sunday"),
        Vue.i18n.translate("tacShop.formatDateRange.monday"),
        Vue.i18n.translate("tacShop.formatDateRange.tuesday"),
        Vue.i18n.translate("tacShop.formatDateRange.wednesday"),
        Vue.i18n.translate("tacShop.formatDateRange.thursday"),
        Vue.i18n.translate("tacShop.formatDateRange.friday"),
        Vue.i18n.translate("tacShop.formatDateRange.saturday"),
      ];
      const startDate = new Date(start);
      const endDate = new Date(end);
      const startDayOfWeek = daysOfWeek[startDate.getUTCDay()];
      const startDateFormatted = this.formatDate(startDate);

      return `${startDayOfWeek} ${startDateFormatted}, ${this.formatTime(
        startDate
      )} - ${this.formatTime(endDate)}`;
    },
    formatDate(date) {
      const day = date.getUTCDate().toString().padStart(2, "0");
      const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
      const year = date.getUTCFullYear();

      return `${day}.${month}.${year}`;
    },
    formatTime(date) {
      const hours = date.getUTCHours().toString().padStart(2, "0");
      const minutes = date.getUTCMinutes().toString().padStart(2, "0");

      return `${hours}:${minutes}`;
    },
    previousWeek() {
      this.date.setDate(this.date.getDate() - 7);
      this.date = new Date(this.date);
    },
    nextWeek() {
      this.date.setDate(this.date.getDate() + 7);
      this.date = new Date(this.date);
    },
  },
  computed: {
    ...mapState({
      allCourses: (state) => state.tac.allCourses,
      statusAllCourses: (state) => state.tac.statusAllCourses,
      statusBookCourse: (state) => state.tac.statusBookCourse,
      locale: ({ i18n }) => i18n.locale,
    }),
    previousWeekEnabled() {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const dateCopy = new Date(this.date.getTime());
      dateCopy.setHours(0, 0, 0, 0);
      return dateCopy > now;
    },
    nextWeekEnabled() {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const dateCopy = new Date(this.date.getTime());
      dateCopy.setHours(0, 0, 0, 0);
      return dateCopy <= now;
    },
    showLoadingDialog() {
      return this.status !== "loaded";
    },
  },
  watch: {
    allCourses: {
      handler: function () {
        this.getEvents();
      },
      deep: true,
    },
    statusBookCourse: {
      handler: function () {
        if (this.statusBookCourse === "success") {
          this.status = "loaded";
          this.bookingSuccessDialog = true;
        }
        if (this.statusBookCourse === "failed") {
          this.status = "loaded";
          this.bookingFailedDialog = true;
        }
      },
    },
    date: {
      handler: function () {
        this.$store.dispatch("tac/getAllCourses");
      },
    },
  },
};
</script>
